import ExxonMobil_Upsell_1A from './ExxonMobil_Upsell_1A.jpg';
import ExxonMobil_Upsell_1B from './ExxonMobil_Upsell_1B.jpg';
import ExxonMobil_Upsell_1C from './ExxonMobil_Upsell_1C.jpg';
import GM_4_Wheel_Alignment from './GM_4_Wheel_Alignment.jpg';
import GM_AC_Check from './GM_AC_Check.jpg';
import GM_AC_Odor from './GM_AC_Odor.jpg';
import GM_Battery_Replacement from './GM_Battery_Replacement.jpg';
import GM_Battery_Terminal_Cleaning from './GM_Battery_Terminal_Cleaning.jpg';
import GM_Brake_Flush from './GM_Brake_Flush.jpg';
import GM_Cabin_Air_Filter from './GM_Cabin_Air_Filter.jpg';
import GM_Conventional_Oil from './GM_Conventional_Oil.jpg';
import GM_Coolant_Flush from './GM_Coolant_Flush.jpg';
import GM_Engine_Air_Filter from './GM_Engine_Air_Filter.jpg';
import GM_Engine_Oil from './GM_Engine_Oil.jpg';
import GM_Exterior_Detail from './GM_Exterior_Detail.jpg';
import GM_Front_End_Alignment from './GM_Front_End_Alignment.jpg';
import GM_Fuel_Flush from './GM_Fuel_Flush.jpg';
import GM_Full_Detail from './GM_Full_Detail.jpg';
import GM_Headlamp_Restoration from './GM_Headlamp_Restoration.jpg';
import GM_Interior_Detail from './GM_Interior_Detail.jpg';
import GM_Oil_Change from './GM_Oil_Change.jpg';
import GM_Road_Force_Balance from './GM_Road_Force_Balance.jpg';
import GM_Seasonal_Tires from './GM_Seasonal_Tires.jpg';
import GM_Synthetic_Oil from './GM_Synthetic_Oil.jpg';
import GM_Tire_Rotation from './GM_Tire_Rotation.jpg';
import GM_Tire_Special from './GM_Tire_Special.jpg';
import GM_Transmission_Flush from './GM_Transmission_Flush.jpg';
import GM_Wash_Wax_Vacuum from './GM_Wash_Wax_Vacuum.jpg';
import GM_Wiper_Blades from './GM_Wiper_Blades.jpg';

export const images = {
    ExxonMobil_Upsell_1A,
    ExxonMobil_Upsell_1B,
    ExxonMobil_Upsell_1C,
    GM_4_Wheel_Alignment,
    GM_AC_Check,
    GM_AC_Odor,
    GM_Battery_Replacement,
    GM_Battery_Terminal_Cleaning,
    GM_Brake_Flush,
    GM_Cabin_Air_Filter,
    GM_Conventional_Oil,
    GM_Coolant_Flush,
    GM_Engine_Air_Filter,
    GM_Engine_Oil,
    GM_Exterior_Detail,
    GM_Front_End_Alignment,
    GM_Fuel_Flush,
    GM_Full_Detail,
    GM_Headlamp_Restoration,
    GM_Interior_Detail,
    GM_Oil_Change,
    GM_Road_Force_Balance,
    GM_Seasonal_Tires,
    GM_Synthetic_Oil,
    GM_Tire_Rotation,
    GM_Tire_Special,
    GM_Transmission_Flush,
    GM_Wash_Wax_Vacuum,
    GM_Wiper_Blades,
};
